import React from "react";

export const about = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_34105_2190)">
        <path
          d="M20.028 0.5H4.98117C2.78489 0.5 0.962448 2.27571 0.962448 4.51872V19.5188C0.962448 21.7151 2.73816 23.5375 4.98117 23.5375H19.9813C22.1776 23.5375 24 21.7618 24 19.5188V4.47199C24 2.27571 22.2243 0.5 20.028 0.5V0.5ZM22.1308 19.5188C22.1308 20.6871 21.1962 21.6684 19.9813 21.6684H4.98117C3.81294 21.6684 2.83162 20.7338 2.83162 19.5188V4.47199C2.83162 3.30376 3.76621 2.32244 4.98117 2.32244H19.9813C21.1495 2.32244 22.1308 3.25703 22.1308 4.47199V19.5188Z"
          fill="currentColor"
        />
        <path
          d="M14.9812 12.0889C15.7289 11.4347 16.1962 10.4533 16.1962 9.37857C16.1962 7.36921 14.5607 5.68695 12.5046 5.68695C10.4952 5.68695 8.81297 7.32248 8.81297 9.37857C8.81297 10.4533 9.28026 11.4347 10.0279 12.1356C8.01857 13.0702 6.56996 15.0795 6.56996 17.4627C6.56996 17.9768 6.99053 18.3973 7.50455 18.3973H16.1962H17.4112C17.9252 18.3973 18.3457 17.9768 18.3457 17.4627C18.3925 15.0795 16.9906 13.0235 14.9812 12.0889V12.0889ZM12.5046 7.50939C13.4859 7.50939 14.327 8.30379 14.327 9.33184C14.327 10.3599 13.5326 11.1543 12.5046 11.1543C11.4765 11.1543 10.6821 10.3599 10.6821 9.33184C10.6821 8.30379 11.5233 7.50939 12.5046 7.50939V7.50939ZM8.76624 16.4814C8.71951 16.4814 8.62605 16.4814 8.57932 16.4814C8.99989 14.7057 10.6354 13.3973 12.5046 13.3973C14.3738 13.3973 16.0093 14.7524 16.4298 16.4814C13.8597 16.4814 11.3364 16.4814 8.76624 16.4814V16.4814Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_34105_2190">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.499969)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
